module.exports = "/resources/assets/prod/c503402c3fc4d979e085705c444cb616.svg";